import Swal from "sweetalert2";
import "./documentViewer.css";
import { ImageProcessor } from "../shared/utils/ImageProcessor.js";
import { ApiService } from "../shared/services/ApiService.js";
import { AuthService } from "../shared/services/AuthService.js";

const DOC_TYPES = {
	DNI_FRENTE: 1,
	DNI_DORSO: 2,
	CEDULA_FRENTE: 4,
	CEDULA_DORSO: 5,
	LICENCIA_FRENTE: 6,
	LICENCIA_DORSO: 7,
	OTROS: 8,
	SEGURO_FRENTE: 9,
	SEGURO_DORSO: 10
};

const DOC_LABELS = {
	1: "DNI - Frente",
	2: "DNI - Dorso",
	4: "Cedula - Frente",
	5: "Cedula - Dorso",
	6: "Licencia - Frente",
	7: "Licencia - Dorso",
	8: "Otro documento",
	9: "Tarjeta de circulación - Frente",
	10: "Tarjeta de circulación - Dorso"
};

const isPdf = (url = "") => url.toLowerCase().endsWith(".pdf");

const showLoading = (text = "Procesando...") => {
	Swal.fire({
		title: text,
		allowOutsideClick: false,
		didOpen: () => {
			Swal.showLoading();
		}
	});
};



const openFilePicker = (callback) => {
	const input = document.createElement("input");
	input.type = "file";
	input.accept = "image/*,application/pdf";
	input.onchange = e => {
		const file = e.target.files[0];
		if (file) callback(file);
	};
	input.click();
};

const normalizeDocs = (docs = []) => {
	const find = (t) => docs.find(d => d.IdTipo === t) || null;

	return {
		dni: {
			frente: find(DOC_TYPES.DNI_FRENTE),
			dorso: find(DOC_TYPES.DNI_DORSO)
		},
		licencia: {
			frente: find(DOC_TYPES.LICENCIA_FRENTE),
			dorso: find(DOC_TYPES.LICENCIA_DORSO)
		},
		otros: docs.filter(d => d.IdTipo === DOC_TYPES.OTROS),
		cedula: {
			frente: find(DOC_TYPES.CEDULA_FRENTE),
			dorso: find(DOC_TYPES.CEDULA_DORSO)
		},
		seguro: {
			frente: find(DOC_TYPES.SEGURO_FRENTE),
			dorso: find(DOC_TYPES.SEGURO_DORSO)
		}
	};
};

const renderPreview = (doc) => {
	if (!doc) return `<div class="doc-empty">No cargado</div>`;
	return isPdf(doc.Url)
		? `<iframe src="${doc.Url}" class="doc-pdf"></iframe>`
		: `<img src="${doc.Url}" class="doc-img" />`;
};

const renderItem = (doc, tipo) => `
	<div class="doc-item">
		<h6>${DOC_LABELS[tipo]}</h6>
			${renderPreview(doc)}
		<button data-doc-id="${doc?.Id || ""}" data-tipo="${tipo}">
		${doc ? "Reemplazar" : "Cargar"}
		</button>
	</div>
`;

const renderItemVehiculo = (doc, tipo, dominio) => `
	<div class="doc-item">
		<h6>${DOC_LABELS[tipo]}</h6>
			${renderPreview(doc)}
		<button data-doc-id="${doc?.Id || ""}" data-tipo="${tipo}" data-dominio="${dominio}">
		${doc ? "Reemplazar" : "Cargar"}
		</button>
	</div>
`;

const renderOtroItem = (doc) => `
	<div class="doc-item">
		<h6>Documento</h6>
		${renderPreview(doc)}
		<button class="btn-danger" data-delete="${doc.Url}">
			Borrar
		</button>
	</div>
`;

const replaceFile = async (file, tipo, dominio) => {
	try {

		const processed = await ImageProcessor.process(file, {
			quality: 0.6,
			maxWidth: 640,
			maxHeight: 640
		});

		const formData = new FormData();
		formData.append("file", processed);

		const user = AuthService.getCurrentUser();

		let endpoint = `apiapp/AgregarDocumentacion?TipoArchivo=${tipo}`;

		if (tipo == DOC_TYPES.CEDULA_FRENTE || tipo == DOC_TYPES.CEDULA_DORSO ||
			tipo == DOC_TYPES.SEGURO_FRENTE || tipo == DOC_TYPES.SEGURO_DORSO) {
			endpoint = `apiapp/AgregarDocumentacionVehiculo?TipoArchivo=${tipo}&Dominio=${dominio}`;
		}

		const resp = await ApiService.post(endpoint, formData, user?.token);

		if (resp.status < 1) {
			throw new Error(resp.message || "Error al subir archivo");
		}




		return {
			url: resp.message
		};

	} catch (err) {
		console.error(err);
		Swal.fire("Error", "No se pudo reemplazar el archivo", "error");
		return null;
	}
};

const addFile = async (file, tipo, dominio) => {
	return replaceFile(file, tipo, dominio);
};

const deleteFile = async (archivo) => {
	try {
		const confirm = await Swal.fire({
			title: "Eliminar documento",
			text: "¿Deseas eliminar este archivo?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Eliminar",
			cancelButtonText: "Cancelar"
		});

		if (!confirm.isConfirmed) return false;


		showLoading("Eliminando documento...");

		const user = AuthService.getCurrentUser();
		const resp = await ApiService.post(`apiapp/QuitarDocumentacion?archivo=${archivo}`, null, user?.token);



		if (resp.status < 1) {
			throw new Error(resp.message);
		}

		return true;
	} catch (err) {
		console.error(err);
		Swal.close();
		Swal.fire("Error", "No se pudo eliminar el archivo", "error");
		return false;
	}
};

const notifyReload = (mensaje, onReload, keepOpen = false) => {
	if (!keepOpen) {
		Swal.close();
	}

	Swal.fire({
		toast: true,
		position: "top-end",
		icon: "info",
		title: `${mensaje}`,
		showConfirmButton: false,
		timer: 2500,
		timerProgressBar: true
	});
	onReload?.();
};

const bindActions = (onReload, keepOpenOnUpload = false) => {
	document.querySelectorAll("[data-tipo]").forEach(btn => {
		btn.onclick = () => {
			const docId = btn.dataset.docId;
			const tipo = btn.dataset.tipo;
			const dominio = btn.dataset.dominio;

			openFilePicker(async (file) => {

				const container = btn.closest(".doc-item");
				// activar loader local
				container.classList.add("uploading");

				const ok = docId
					? await replaceFile(file, tipo, dominio) // DNI / Licencia / Cedula / Seguro
					: await addFile(file, tipo, dominio);     // Otros (nuevo)


				// quitar loader
				container.classList.remove("uploading");

				if (!ok) return;
				if (keepOpenOnUpload) {
					// actualización parcial del DOM
					updateDocItem(btn, ok, tipo, dominio, onReload);
				} else {
					// comportamiento normal
					notifyReload("Archivos cargados correctamente", onReload, keepOpenOnUpload);
				}

			});
		};
	});

	document.querySelectorAll("[data-delete]").forEach(btn => {
		btn.onclick = async () => {
			const filePath = btn.dataset.delete;

			const ok = await deleteFile(filePath);
			if (ok) notifyReload("Archivo eliminado correctamente", onReload, keepOpenOnUpload);
		};
	});

};

const updateDocItem = (btn, ok, tipo, dominio, onReload) => {

	const container = btn.closest(".doc-item");
	const newUrl = ok.url;

	const newPreview = isPdf(newUrl)
		? `<iframe src="${newUrl}" class="doc-pdf"></iframe>`
		: `<img src="${newUrl}" class="doc-img" />`;

	container.innerHTML = `
		<h6>${DOC_LABELS[tipo]}</h6>
		${newPreview}
		<button data-doc-id="${ok.id || ""}" 
		        data-tipo="${tipo}" 
		        data-dominio="${dominio || ""}">
			Reemplazar
		</button>
	`;

	bindActions(onReload, true);

};


const openModal = ({ title, html, onReload, keepOpenOnUpload = false }) => {
	Swal.fire({
		title,
		html,
		width: 900,
		showCloseButton: true,
		didOpen: () => bindActions(onReload, keepOpenOnUpload)
	});
};

/* ===========================
   API PÚBLICA (lo único visible)
   =========================== */

export const DocumentViewer = {
	openDni(docs, onReload) {
		const d = normalizeDocs(docs);
		openModal({
			title: "Documento Nacional de Identidad",
			html: `
				<div class="doc-grid">
					${renderItem(d.dni.frente, DOC_TYPES.DNI_FRENTE)}
					${renderItem(d.dni.dorso, DOC_TYPES.DNI_DORSO)}
				</div>
			`,
			onReload
		});
	},

	openLicencia(docs, onReload) {
		const d = normalizeDocs(docs);
		openModal({
			title: "Licencia de Conducir",
			html: `
        <div class="doc-grid">
          ${renderItem(d.licencia.frente, DOC_TYPES.LICENCIA_FRENTE)}
          ${renderItem(d.licencia.dorso, DOC_TYPES.LICENCIA_DORSO)}
        </div>
      `,
			onReload
		});
	},

	openDocumentacionVehiculo(dominio, docs, onReload) {
		const d = normalizeDocs(docs);
		openModal({
			title: "Documentación del vehículo " + dominio,
			html: `
        <div class="doc-grid">
          ${renderItemVehiculo(d.cedula.frente, DOC_TYPES.CEDULA_FRENTE, dominio)}
          ${renderItemVehiculo(d.cedula.dorso, DOC_TYPES.CEDULA_DORSO, dominio)}
        </div>
      `,
			onReload
		});
	},

	openSeguroVehiculo(dominio, docs, onReload) {
		const d = normalizeDocs(docs);

		//const cargaInicial = !d.seguro.frente && !d.seguro.dorso;


		openModal({
			title: "Seguro del vehículo " + dominio,
			html: `
        <div class="doc-grid">
          ${renderItemVehiculo(d.seguro.frente, DOC_TYPES.SEGURO_FRENTE, dominio)}
          ${renderItemVehiculo(d.seguro.dorso, DOC_TYPES.SEGURO_DORSO, dominio)}
        </div>
      `,
			onReload,
			keepOpenOnUpload: true
		});
	},

	openOtros(docs, onReload) {
		const d = normalizeDocs(docs);
		openModal({
			title: "Otros documentos",
			html: `
      <div class="doc-grid">
        ${d.otros.map(o => renderOtroItem(o)).join("")}
        <div class="doc-add">
          <button data-tipo="${DOC_TYPES.OTROS}">
            ➕ Agregar documento
          </button>
        </div>
      </div>
    `,
			onReload
		});
	}
};